import axios from 'axios';
import { env } from '@/core/config/env';
import { setupAuthInterceptor } from './interceptors/authInterceptor';
import { setupRefreshInterceptor } from './interceptors/refreshInterceptor';
import { setupRequestIdInterceptor } from './interceptors/requestIdInterceptor';
import { setupErrorInterceptor } from './interceptors/errorInterceptor';
export const apiClient = axios.create({
    baseURL: env.apiBaseUrl,
    timeout: 30_000,
    headers: { 'Content-Type': 'application/json' },
});
setupRequestIdInterceptor(apiClient);
setupAuthInterceptor(apiClient);
setupRefreshInterceptor(apiClient);
setupErrorInterceptor(apiClient);
